/**
 * Helper function to conditionally join class names together
 * @example className={cn('text-black', isActive && 'bg-blue-500')}
 */
export function cn(...classNames: (string | boolean | undefined | null)[]) {
  return classNames.filter(Boolean).join(' ')
}

export const Encode = (salt: string, text: string) => {
  try {
    return btoa(salt + text)
  } catch (err) {
    console.error(err)
    return Buffer.from(salt + text).toString('base64')
  }
}

export const shuffleArray = <T>(array: T[]): T[] => {
  return array.sort(() => Math.random() - 0.5)
}
